import React, { useState } from 'react';
import PortfolioCard from './PortfolioCard';
import { Briefcase, Code, BookOpen, GraduationCap, FileCheck, Sparkles } from 'lucide-react';
import ExperienceModal from './modals/ExperienceModal';
import ProjectsModal from './modals/ProjectsModal';
import SkillsModal from './modals/SkillsModal';
import EducationModal from './modals/EducationModal';
import CertificationsModal from './modals/CertificationsModal';
import ResearchPublicationsModal from './modals/ResearchPublicationsModal';

const MainPortfolio = ({ portfolioData }) => {
  const [activeModal, setActiveModal] = useState(null);

  const cards = [
    {
      id: 'experience',
      icon: Briefcase,
      title: 'Experience',
      subtitle: '3+ years in finance & tech',
      gradient: 'bg-gradient-to-br from-blue-600 to-blue-800',
      modal: 'experience'
    },
    {
      id: 'projects',
      icon: Code,
      title: 'Projects',
      subtitle: 'AI-powered finance solutions',
      gradient: 'bg-gradient-to-br from-purple-600 to-purple-800',
      modal: 'projects'
    },
    {
      id: 'skills',
      icon: Sparkles,
      title: 'Skills',
      subtitle: 'Full-stack & finance expertise',
      gradient: 'bg-gradient-to-br from-cyan-600 to-cyan-800',
      modal: 'skills'
    },
    {
      id: 'education',
      icon: GraduationCap,
      title: 'Education',
      subtitle: '4.0 GPA | MS Finance',
      gradient: 'bg-gradient-to-br from-green-600 to-green-800',
      modal: 'education'
    },
    {
      id: 'certifications',
      icon: FileCheck,
      title: 'Certifications',
      subtitle: '6+ professional certifications',
      gradient: 'bg-gradient-to-br from-yellow-600 to-yellow-800',
      modal: 'certifications'
    },
    {
      id: 'research',
      icon: BookOpen,
      title: 'Research Publications',
      subtitle: 'Published in Springer',
      gradient: 'bg-gradient-to-br from-pink-600 to-pink-800',
      modal: 'research'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950 pt-24 pb-12 px-6">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Explore My Portfolio
          </h2>
          <p className="text-xl text-slate-400">
            Click on any card to learn more about my journey
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card) => (
            <PortfolioCard
              key={card.id}
              icon={card.icon}
              title={card.title}
              subtitle={card.subtitle}
              gradient={card.gradient}
              onClick={() => setActiveModal(card.modal)}
            />
          ))}
        </div>
      </div>

      {/* Modals */}
      <ExperienceModal
        isOpen={activeModal === 'experience'}
        onClose={() => setActiveModal(null)}
        experience={portfolioData.experience}
      />
      
      <ProjectsModal
        isOpen={activeModal === 'projects'}
        onClose={() => setActiveModal(null)}
        projects={portfolioData.projects}
      />
      
      <SkillsModal
        isOpen={activeModal === 'skills'}
        onClose={() => setActiveModal(null)}
        skills={portfolioData.skills}
      />
      
      <EducationModal
        isOpen={activeModal === 'education'}
        onClose={() => setActiveModal(null)}
        education={portfolioData.education}
      />
      
      <CertificationsModal
        isOpen={activeModal === 'certifications'}
        onClose={() => setActiveModal(null)}
        certifications={portfolioData.certifications}
      />

      <ResearchPublicationsModal
        isOpen={activeModal === 'research'}
        onClose={() => setActiveModal(null)}
        publications={portfolioData.researchPublications}
      />
    </div>
  );
};

export default MainPortfolio;
